<template>
  <div v-if="selectedCounts" class="summary">
    <div class="summary__blocks">
      <div
        v-for="item in computedItems"
        :key="item.id"
        class="summary__block"
        :class="{
          summary__block_checked: selectedBlocks.includes(item.id),
        }"
        @click="selectBlock(item.id, item.ableRowsCount === 0)"
      >
        <div class="block__number">
          {{ item.order + 1 }}
        </div>
        <Checkbox
          :checked="selectedBlocks.includes(item.id)"
          :partially="item.ableRowsCount > item.selectedPositionsCount"
          :disabled="item.ableRowsCount === 0"
          @check="selectBlock(item.id)"
        />
        <div class="block__info">
          <div class="block__title">
            {{ item.title }}
          </div>
          <div class="block__text">
            <span v-if="item.ableRowsCount === 0">
              {{ $t('All items assigned to other tenders') }}
            </span>
            <span v-else>
              {{ item.selectedPositionsCount }}
              {{ $t('assigned positions') }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Checkbox from '@/components/ui/Checkbox';

  export default {
    name: 'Summary',
    components: {
      Checkbox,
    },
    model: {
      prop: 'selectedBlocks',
      event: 'select',
    },
    props: {
      items: {
        type: Array,
        required: true,
      },
      selectedCounts: {
        type: Object,
        required: true,
      },
      selectedBlocks: {
        type: Array,
        default: () => [],
      },
      mainRows: {
        type: Array,
        required: true,
      },
      disabledRows: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      computedItems() {
        return this.items.map((item) => {
          // выбранные строки без родительских
          const selectedRows = this.selectedCounts[item.id].filter(
            (id) => !this.mainRows.includes(id)
          );
          // сколько вообще недоступных строк в листе
          let disabledPositionsCount = 0;
          // сколько вообще строк в листе дочерних
          let rootLevelRowsCount = 0;
          item.rows.forEach((row) => {
            if (!row.group_level) {
              rootLevelRowsCount += 1;
              if (this.disabledRows.includes(row.id)) {
                disabledPositionsCount += 1;
              }
            }
          });
          return {
            ...item,
            selectedPositionsCount: selectedRows.length || 0,
            ableRowsCount: rootLevelRowsCount - disabledPositionsCount,
          };
        });
      },
    },
    methods: {
      selectBlock(id, disabled) {
        if (!disabled) {
          this.$emit('select', {
            addList: !this.selectedBlocks.includes(id),
            id,
          });
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/styles/colors';

  .summary {
    background-color: white;
  }

  .summary__blocks {
    padding: 10px 20px;
  }

  .summary__block {
    cursor: pointer;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 12px 20px;
    margin-bottom: 12px;

    background: white;
    border: 1px solid $grey200;
    box-sizing: border-box;
    border-radius: 8px;

    &:hover {
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04), 0 2px 8px rgba(0, 0, 0, 0.08);
    }

    &_checked {
      border-color: $primary500;
    }

    &_disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  .block__title {
    margin-bottom: 4px;
    color: $grey900;
    font-weight: bold;
    font-size: 14px;
  }

  .block__text {
    color: $grey600;
    font-weight: 500;
    font-size: 14px;
  }

  .block__number {
    color: $grey600;
    margin-right: 8px;
    font-weight: 500;
    font-size: 14px;
  }

  .block__info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    margin-left: 16px;
  }
</style>
